"use client";

import { useState } from "react";

import { ChatComposer } from "./ChatComposer";
import { ExampleWorkflowsLink } from "./ExampleWorkflowsLink";
import { HomeGreeting } from "./HomeGreeting";
import type { ComposerMode } from "./modes";

interface ChatProps {
  onSubmit?: (value: string, mode: ComposerMode) => void;
}

export function Chat({ onSubmit }: ChatProps) {
  const [prompt, setPrompt] = useState("");
  const [examplesOpen, setExamplesOpen] = useState(false);

  return (
    <>
      <HomeGreeting />
      <ChatComposer value={prompt} onChange={setPrompt} onSubmit={onSubmit} />
      <ExampleWorkflowsLink
        open={examplesOpen}
        onToggle={() => setExamplesOpen((open) => !open)}
        onSelect={(example) => {
          setPrompt(example);
          setExamplesOpen(false);
        }}
      />
    </>
  );
}
